var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round;stroke-width:2px;}"))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logout"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 15.92,
    x2: 28.92,
    y1: 16,
    y2: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.93,25v3h-16V4h16V7h2V3a1,1,0,0,0-1-1h-18a1,1,0,0,0-1,1V29a1,1,0,0,0,1,1h18a1,1,0,0,0,1-1V25Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.92,
    x2: 24.92,
    y1: 16,
    y2: 20
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 28.92,
    x2: 24.92,
    y1: 16,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.92,
    x2: 24.92,
    y1: 8.09,
    y2: 6.09
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 24.92,
    x2: 24.92,
    y1: 26,
    y2: 24
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOut);
export default __webpack_public_path__ + "static/media/sign_out.5c513b805bdafad5a1f36b4946ef1c2a.svg";
export { ForwardRef as ReactComponent };